export default __webpack_public_path__ + "static/media/logo2.ef5ce0c0.png";